// Entrada pelo site (pagar antes de baixar — AC-257 / AC-258): "Baixar para Windows" e os planos
// levam à versão web com ?criar=1 (abre direto em "Criar conta") e ?plano=mensal|anual (o plano já
// vem marcado na tela de planos). O plano fica guardado no navegador por 7 dias, para valer também
// depois de confirmar o e-mail numa aba nova.
import type { Plan } from '../domain/access';

const KEY = 'bdi-plano';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
const PLANS: Record<string, Plan> = { mensal: 'monthly', anual: 'annual', monthly: 'monthly', annual: 'annual' };

let signUpFirst = false;

type Store = Pick<Storage, 'getItem' | 'setItem'>;

/** Lê ?criar e ?plano, guarda e tira os dois da barra de endereços. */
export function captureEntry(href: string, storage: Store | undefined, replaceUrl: (url: string) => void, now = Date.now()): void {
  const url = new URL(href);
  if (!url.searchParams.has('criar') && !url.searchParams.has('plano')) return;
  signUpFirst = url.searchParams.has('criar');
  const plan = PLANS[url.searchParams.get('plano') ?? ''];
  url.searchParams.delete('criar');
  url.searchParams.delete('plano');
  replaceUrl(url.pathname + url.search + url.hash);
  if (!plan || !storage) return;
  try {
    storage.setItem(KEY, JSON.stringify({ plan, at: now }));
  } catch {
    /* sem armazenamento: o mensal vem marcado */
  }
}

/** Veio do site para criar a conta: a entrada abre em "Criar conta" (uma vez). */
export function takeSignUpFirst(): boolean {
  const v = signUpFirst;
  signUpFirst = false;
  return v;
}

/** Plano escolhido no site, se ainda vale (7 dias). */
export function chosenPlan(storage: Pick<Storage, 'getItem'> | undefined, now = Date.now()): Plan | null {
  try {
    const raw = storage?.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as { plan?: Plan; at?: number };
    if (!saved.at || now - saved.at > MAX_AGE_MS) return null;
    return saved.plan === 'annual' || saved.plan === 'monthly' ? saved.plan : null;
  } catch {
    return null;
  }
}
